import { useFixAndroidScrollInput } from "./useFixAndroidScrollInput";

export const FixAndroidScrollInput = () => {
  useFixAndroidScrollInput();
  return null;
};
